import {
  ApiPrefixes,
  AuthApiSlugs,
  TokenExpireTimestampDto,
  UserRegistrationCreationDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../api-caller.service';

export class SignUpConnector {
  private slug = AuthApiSlugs.SIGN_UP;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  createWithToken(dto: UserRegistrationCreationDto): Observable<TokenExpireTimestampDto> {
    return this.apiCaller.postRequest<TokenExpireTimestampDto>(ApiPrefixes.AUTH, this.slug, dto);
  }
}
